/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuthContext } from "hooks/AuthContext";
import DashIcon from "components/icons/DashIcon";
// chakra imports

export const SidebarLinks = (props: { routes: RoutesType[] }): JSX.Element => {
  // Chakra color mode
  let location = useLocation();

  const { routes } = props;
  const { user } = useAuthContext();

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes: RoutesType[]) => {
    // determine current layout from location (e.g., '/admin' or '/user')
    const firstSegment = location.pathname.split("/")[1] || "admin";
    const desiredLayout = `/${firstSegment}`;
    const role = user?.role || "guest";

    return routes
      .filter((route) => route.layout === desiredLayout)
      .filter((route) => {
        // Hide routes that are in-page actions or resource detail/edit/create routes
        if (!route.path) return false;
        const p = route.path;
        if (
          p.includes("create") ||
          p.includes("edit") ||
          p.includes("upload") ||
          p.includes(":")
        )
          return false;
        // If route defines roles, ensure current role is allowed
        if (route.roles && Array.isArray(route.roles)) {
          if (!route.roles.includes(role)) return false;
        }
        return true;
      })
      .map((route, index) => {
        const isActive = activeRoute(route.path);
        return (
          <li key={index} className="relative mb-2 list-none">
            <Link
              to={route.layout + "/" + route.path}
              aria-current={isActive ? "page" : undefined}
              className={`group flex w-full items-center gap-3 rounded-lg px-3 py-2 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-brand-300 focus:ring-offset-2 dark:focus:ring-offset-navy-800 ${
                isActive
                  ? "bg-brand-50 text-brand-600 dark:bg-navy-700 dark:text-white"
                  : "text-gray-600 hover:bg-gray-100 hover:text-brand-600 dark:hover:bg-navy-700"
              }`}
            >
              <span
                className={`flex-none transition-colors duration-150 ${
                  isActive
                    ? "text-brand-600"
                    : "text-gray-600 group-hover:text-brand-600"
                }`}
              >
                {route.icon ? route.icon : <DashIcon />}
              </span>
              <p
                className={`truncate text-sm ${
                  isActive ? "font-semibold" : "font-medium"
                }`}
              >
                {route.name}
              </p>
              {isActive ? (
                <div className="absolute right-0 top-2 h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
              ) : null}
            </Link>
          </li>
        );
      });
  };
  // BRAND
  return <>{createLinks(routes)}</>;
};

export default SidebarLinks;
